import AccountRecoveryMethodForm from './AccountRecoveryMethodForm';

export default AccountRecoveryMethodForm;


// WEBPACK FOOTER //
// ./src/components/forms/AccountRecoveryMethodForm/index.js